import type { PBJFacilityInfo } from "../../utils/models";

/** "Name — City, ST — CCN" for a searched facility; a nameless result degrades to its bare CCN. */
export const facilityLabel = (facility: PBJFacilityInfo): string =>
	facility.provname ? `${facility.provname} — ${facility.city}, ${facility.state} — ${facility.provnum}` : facility.provnum;
